<!-- https://8es9hr.axshare.com/#g=1&p=%E9%80%BE%E9%BD%A1%E8%82%A1%E9%87%91%E5%8F%8A%E6%94%BE%E6%AC%BE
     https://8es9hr.axshare.com/#g=1&p=%E4%BA%92%E5%8A%A9%E8%B2%BBlpls%E7%94%B3%E5%A0%B1%E8%A1%A8 -->
<!-- LPLS申報表明細報表
     互助費lpls申報表 -->
<template>
	<div class="row">
		<div class="col-12">
			<ListForm
				api
				labelPosition="top"
				:formTitle="`${title}`"
				:recordToEdit="recordToEdit"
				:formType="formType[0]"
				ref="reLabel"
				v-if="title !== '互助費LPLS申報表'"
			>
				<div slot="footer" class="dialog-footer">
					<el-button type="primary" @click="getData">查詢</el-button>
					<!-- 查詢結果 -->
				</div>
			</ListForm>
			<ListForm
				api
				labelPosition="top"
				:formTitle="`${title}`"
				:recordToEdit="recordToEdit"
				:formType="formType[1]"
				ref="reLabel"
				v-else
			>
				<div slot="footer" class="dialog-footer">
					<!-- LPLS 申報表額填報資訊 -->
					<table class="table table-bordered mb-0 mt10">
						<thead class="grey lighten-4">
							<tr>
								<th width="700">其他應扣股金 ( LS列舉細目 )</th>
								<th width="400">本次補助金額</th>
								<th>已由公積金沖銷之貸款結餘</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td class="text-center td-set">
									<el-input
										v-model="recordToEdit.otherName1"
										class="mr-3 flex-set"
										:disabled="true"
									></el-input>
									<el-input-number
										v-model="recordToEdit.otherAmount1"
										class="input-set"
										:disabled="true"
										:controls="false"
										placeholder="請填寫金額"
									></el-input-number>
								</td>
								<td class="text-left">
									<span class="span-set">本次補繳 -</span>
									<el-input-number
										v-model="recordToEdit.markeupAmount"
										:controls="false"
										:min="0"
										class="input-set"
										placeholder="請填寫本次補繳金額"
									></el-input-number>
								</td>
								<td class="text-center">
									<el-input
										class
										placeholder="請填寫結餘"
										v-model="recordToEdit.reversalAmount"
									></el-input>
								</td>
							</tr>
							<tr>
								<td class="text-center td-set">
									<el-input
										v-model="recordToEdit.otherName2"
										class="mr-3 flex-set"
										placeholder="請填寫細項"
									></el-input>
									<el-input-number
										v-model="recordToEdit.otherAmount2"
										:controls="false"
										class="input-set"
										placeholder="請填寫金額"
									></el-input-number>
								</td>
								<td class="text-left">
									<span class="span-set">本次抵繳 -</span>

									<el-input-number
										v-model="recordToEdit.creditAmount"
										:controls="false"
										:min="0"
										class="input-set"
										placeholder="請填寫本次抵繳金額"
									></el-input-number>
								</td>
							</tr>
							<tr>
								<td class="text-center td-set">
									<el-input
										v-model="recordToEdit.otherName3"
										class="mr-3 flex-set"
										placeholder="請填寫細項"
									></el-input>
									<el-input-number
										v-model="recordToEdit.otherAmount3"
										:controls="false"
										class="input-set"
										placeholder="請填寫金額"
									></el-input-number>
								</td>
								<td class="text-left">
									<span class="span-set">本次匯款 -</span>
									<el-input-number
										v-model="recordToEdit.remitAmount"
										:controls="false"
										:min="0"
										class="input-set"
										placeholder="請填寫本次匯款金額"
									></el-input-number>
								</td>
							</tr>
						</tbody>
					</table>
					<br />
					<el-button type="primary" @click="getData">查詢</el-button>
					<!-- 查詢結果 -->
				</div>
			</ListForm>

			<div class="show-container">
				<div class="show"></div>
			</div>
		</div>
	</div>
</template>
<script>
// $(function() {
//     $("#datepicker").datepicker();
//     $.datepicker.regional["zh-TW"];
// });
// import $ from "jquery";
import ListForm from "@/components/ListForm.vue";
import { API } from "@/assets/config";
export default {
	name: "lpls_report",
	components: { ListForm },
	data() {
		return {
			form: {},
			value: "",
			url: "",
			title: this.$route.query.type,
			recordToEdit: {
				accountStart: "",
				accountEnd: "",
				searchDate: "",
				otherName1: "超過3000股金",
				otherAmount1: "",
				otherName2: "",
				otherAmount2: "",
				otherName3: "",
				otherAmount3: "",
				markeupAmount: "",
				creditAmount: "",
				remitAmount: "",
				reversalAmount: "0",
			},
			formType: [
				[
					{
						label: "起訖帳號",
						key: ["accountStart", "accountEnd"],
						returnKey: "account",
						type: "chooseMemberRange",
					},
					{
						label: "查詢日期",
						key: "searchDate",
						type: "date",
						require: true,
					},
				],
				[
					{
						label: "查詢日期",
						key: "searchDate",
						type: "date",
						require: true,
					},
					// {
					//     label: "過濾項目",
					//     key: "filterType",
					//     type: "radio",
					//     options: [
					//         {
					//             label: "0",
					//             value: 0
					//         }
					//     ]
					// }
					// {
					//     label: "細項1",
					//     key: "otherName1",
					//     type: "input",
					//     disabled: true,
					//     palceholderTitleChange: "預設帶入"
					// },
					// {
					//     label: "細項1-金額",
					//     key: "otherAmount1",
					//     type: "input",
					//     disabled: true,
					//     palceholderTitleChange: "預設帶入"
					// },
					// {
					//     label: "本次補繳",
					//     key: "markeupAmount",
					//     type: "input"
					// },
					// {
					//     label: "細項2",
					//     key: "otherName2",
					//     type: "input"
					// },
					// {
					//     label: "細項2-金額",
					//     key: "otherAmount2",
					//     type: "input"
					// },
					// {
					//     label: "本次抵繳",
					//     key: "creditAmount",
					//     type: "input"
					// },
					// {
					//     label: "細項3",
					//     key: "otherName3",
					//     type: "input"
					// },
					// {
					//     label: "細項3-金額",
					//     key: "otherAmount3",
					//     type: "input"
					// },
					// {
					//     label: "本次抵繳",
					//     key: "remitAmount",
					//     type: "input"
					// }
				],
			],
		};
	},
	methods: {
		getData() {
			try {
				this.check();
			} catch (error) {
				this.$message.error(error.message);
				return;
			}
			const vm = this;
			const url = API.coopLplsReport;

			/* vm.changeApi.forEach(function(vel, idx) {
        if (vm.title === vel.name) {
          url =
            API.coopInsLplsReport +
            `?action=CorporateTransfer&account_start=${vm.account_start}&account_end=${vm.account_end}&balance_date=${vm.date}`;
          console.log(vm.title,vel.name);
        }
      }); */

			let params = {};
			let date =
				parseInt($(`.searchDate`).val().split("-")[0]) +
				1911 +
				$(`.searchDate`).val().slice(3);
			switch (this.title) {
				case "逾齡股金及放款":
					params = {
						action: "OveragedSharesLoans",
						accountStart: this.recordToEdit.accountStart,
						accountEnd: this.recordToEdit.accountEnd,
						balanceDate: date,
					};
					break;
				case "逾齡備轉金":
					params = {
						action: "OverageAllowance",
						accountStart: this.recordToEdit.accountStart,
						accountEnd: this.recordToEdit.accountEnd,
						balanceDate: date,
					};
					break;
				case "不合格放款":
					params = {
						action: "UnqualifiedLoan",
						accountStart: this.recordToEdit.accountStart,
						accountEnd: this.recordToEdit.accountEnd,
						balanceDate: date,
					};
					break;
				case "法人備轉金":
					params = {
						action: "CorporateTransfer",
						accountStart: this.recordToEdit.accountStart,
						accountEnd: this.recordToEdit.accountEnd,
						balanceDate: date,
					};
					break;
				case "法人股金及放款":
					params = {
						action: "LegalPersonSharesLoans",
						accountStart: this.recordToEdit.accountStart,
						accountEnd: this.recordToEdit.accountEnd,
						balanceDate: date,
					};
					break;
				case "超額備轉金":
					params = {
						action: "ExcessTransfer",
						accountStart: this.recordToEdit.accountStart,
						accountEnd: this.recordToEdit.accountEnd,
						balanceDate: date,
					};
					break;
				case "超額股金及放款":
					params = {
						action: "ExcessCapitalLoans",
						accountStart: this.recordToEdit.accountStart,
						accountEnd: this.recordToEdit.accountEnd,
						balanceDate: date,
					};
					break;
				case "逾齡附加放款清冊":
					params = {
						action: "OverageAdditionalLoanInventory",
						accountStart: this.recordToEdit.accountStart,
						accountEnd: this.recordToEdit.accountEnd,
						balanceDate: date,
					};
					break;
				case "股金超過3000元":
					params = {
						action: "OverStockAmount",
						accountStart: this.recordToEdit.accountStart,
						accountEnd: this.recordToEdit.accountEnd,
						balanceDate: date,
					};
					break;
				case "逾期18個月放款":
					params = {
						action: "Overdue18MonthsLoan",
						accountStart: this.recordToEdit.accountStart,
						accountEnd: this.recordToEdit.accountEnd,
						balanceDate: date,
					};
					break;
				case "青年附加契約明細表":
					params = {
						action: "YoungAdditional",
						accountStart: this.recordToEdit.accountStart,
						accountEnd: this.recordToEdit.accountEnd,
						balanceDate: date,
					};
					break;
				case "LS個人最高給付額表":
					params = {
						action: "LSStockAmountLimit",
						accountStart: this.recordToEdit.accountStart,
						accountEnd: this.recordToEdit.accountEnd,
						balanceDate: date,
					};
					break;
				case "互助費LPLS申報表":
					params = {
						action: "LPLSMonth",
						// accountStart: this.recordToEdit.accountStart,
						// accountEnd: this.recordToEdit.accountEnd,
						balanceDate: date,
						otherName1: this.recordToEdit.otherName1,
						otherAmount1: "",
						otherName2: this.recordToEdit.otherName2,
						otherAmount2: this.recordToEdit.otherAmount2,
						otherName3: this.recordToEdit.otherName3,
						otherAmount3: this.recordToEdit.otherAmount3,
						markeupAmount: this.recordToEdit.markeupAmount,
						creditAmount: this.recordToEdit.creditAmount,
						remitAmount: this.recordToEdit.remitAmount,
						reversalAmount: this.recordToEdit.reversalAmount,
						filterType: 0,
						accountStart: "",
						accountEnd: "",
					};
					break;
			}
			this.mIframePDF(url, params);
		},
		check() {
			if (!$(`.searchDate`).val()) {
				this.$message.closeAll();
				throw new Error("請選擇查詢日期");
			}
		},
		removeIframe() {
			const removeEl = document
				.querySelector(".show-container iframe")
				.remove();
		},
		clearAll() {
			this.recordToEdit.accountStart = "";
			this.recordToEdit.accountEnd = "";
			this.recordToEdit.searchDate = "";
			$(`.searchDate`).val("");
			this.$refs.reLabel.removeLabel(this.formType[0][0].key);
		},
	},
	watch: {
		$route(to, from) {
			const vm = this;
			const removeEl = document.querySelector(".show-container iframe");
			if (removeEl !== null) {
				removeEl.remove();
			}
			if (this.title !== this.$route.query.type) {
				this.clearAll();
			}
			if (this.$route.query.type) {
				this.title = this.$route.query.type;
			}
		},
	},
};
</script>
<style lang="scss" scoped>
#flipFlop {
	z-index: 9999 !important;
}

.td-set {
	display: flex;
}
</style>